import React, {
    ReactElement, useContext, useMemo, useState,
} from "react";

interface ChatState {
    editingMessageId?: string;
    setEditingMessageId(ticketMessageId?: string): void;
    setLastMessageId(id: string): void;
    editLastMessage(): void;
}
export const ChatStateContext = React.createContext<ChatState>({
    setLastMessageId: () => {
        // do nothing
    },
    editLastMessage: () => {
        // do nothing
    },
    setEditingMessageId: () => {
        // nope
    },
});

export function ChatStateProvider({
    children,
}: {
    children: ReactElement | ReactElement[];
}) {
    const [editingMessageId, setEditingMessageId] = useState<string | undefined>(undefined);
    const [lastMessageId, setLastMessageId] = useState<string | undefined>(undefined);

    const value = useMemo(() => ({
        editingMessageId,
        setEditingMessageId,
        setLastMessageId,
        editLastMessage: () => {
            setEditingMessageId(lastMessageId);
        },
    }), [setEditingMessageId, editingMessageId, lastMessageId]);

    return (
        <ChatStateContext.Provider value={value}>
            {children}
        </ChatStateContext.Provider>
    );
}

export default function useChatState(): ChatState {
    return useContext(ChatStateContext);
}
